export default __webpack_public_path__ + "static/media/home1.4bfe88f1.gif";